<template>
  <el-dialog title="添加项目" :visible.sync="visible" width="40%" @close="clearAddCommunityInfo">
    <el-form ref="form" :model="addCommunityInfo" :rules="rules" label-width="120px" class="text-left">
      <el-form-item label="项目名称" prop="name">
        <el-input v-model="addCommunityInfo.name" placeholder="请输入项目名称" />
      </el-form-item>
      <el-form-item label="所在区域" prop="cityCode">
        <area-select ref="areaSelect" @selectArea="selectArea" />
        <el-input v-model="addCommunityInfo.cityCode" style="display: none" />
      </el-form-item>
      <el-form-item label="详细地址" prop="tmpAddress">
        <el-input v-model="addCommunityInfo.tmpAddress" placeholder="请输入详细地址" />
      </el-form-item>
      <el-form-item label="附近地标" prop="nearbyLandmarks">
        <el-input v-model="addCommunityInfo.nearbyLandmarks" placeholder="请输入附近地标" />
      </el-form-item>
      <el-form-item label="联系电话" prop="tel">
        <el-input v-model="addCommunityInfo.tel" placeholder="请输入联系电话" />
      </el-form-item>
      <el-form-item v-for="(item, index) in addCommunityInfo.attrs" :key="index" :label="item.specName"
        :prop="'attrs.' + index + '.value'">
        <el-input v-if="item.specType === '2233'" v-model="item.value" :placeholder="item.specHoldplace ? item.specHoldplace.replace(/^必填，?/, '') : ''" />
        <el-select v-else-if="item.specType === '3344'" v-model="item.value" :placeholder="item.specHoldplace ? item.specHoldplace.replace(/^必填，?/, '') : ''"
          style="width: 100%">
          <el-option v-for="value in item.values" :key="value.value" :label="value.valueName" :value="value.value" />
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="saveCommunityInfo">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveCommunity } from '@/api/community/communityManageApi'
import { getAttrSpecList } from '@/api/dev/attrSpecApi'
import { getAttrValueList } from '@/api/dev/attrValueApi'
import AreaSelect from '@/components/community/areaSelect'

export default {
  name: 'AddCommunity',
  components: { AreaSelect },
  data() {
    return {
      visible: false,
      rules: {
        name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
        cityCode: [{ required: true, message: '请选择所在区域', trigger: 'change' }],
        tmpAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        nearbyLandmarks: [{ required: true, message: '请输入附近地标', trigger: 'blur' }],
        tel: [{ required: true, message: '请输入联系电话', trigger: 'blur' }]
      },
      addCommunityInfo: {
        name: '',
        address: '',
        tmpAddress: '',
        areaAddress: '',
        nearbyLandmarks: '',
        tel: '',
        cityCode: '',
        mapX: '101.33',
        mapY: '101.33',
        attrs: [],
        payFeeMonth: 12,
        feePrice: 0
      }
    }
  },
  methods: {
    openModal() {
      this._loadCommunityAttrSpec()
      this.visible = true
    },
    selectArea(area) {
      this.addCommunityInfo.cityCode = area.selectArea
      this.addCommunityInfo.areaAddress = area.areaAddress || ''
    },
    saveCommunityInfo() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.addCommunityInfo.address = this.addCommunityInfo.areaAddress + this.addCommunityInfo.tmpAddress
        saveCommunity(this.addCommunityInfo).then(() => {
          this.$message.success('添加成功')
          this.visible = false
          this.$emit('listData')
        }).catch(error => {
          this.$message.error(error.message || '添加失败')
        })
      })
    },
    clearAddCommunityInfo() {
      this.$refs.form && this.$refs.form.resetFields()
      this.$refs.areaSelect && this.$refs.areaSelect.clearArea()
      this.addCommunityInfo = {
        name: '',
        address: '',
        tmpAddress: '',
        areaAddress: '',
        nearbyLandmarks: '',
        tel: '',
        cityCode: '',
        mapX: '101.33',
        mapY: '101.33',
        attrs: [],
        payFeeMonth: 12,
        feePrice: 0
      }
    },
    async _loadCommunityAttrSpec() {
      this.addCommunityInfo.attrs = []
      const { data } = await getAttrSpecList({
        page: 1,
        row: 100,
        tableName: 'building_community_attr'
      })
      data.forEach(item => {
        item.value = ''
        if (item.specShow === 'Y') {
          item.values = []
          this._loadAttrValue(item.specCd, item.values)
          this.addCommunityInfo.attrs.push(item)
        }
      })
    },
    async _loadAttrValue(specCd, values) {
      const { data } = await getAttrValueList({ specCd, page: 1, row: 100 })
      data.forEach(item => {
        if (item.valueShow === 'Y') {
          values.push(item)
        }
      })
    }
  }
}
</script>
